<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lfiJ2Q/tc-custom/9781467426435.jpg?1742010697495" alt="This image is the cover for the book A Theology of the New Testament"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Theology of the New Testament
      </h1>
      <p class="bookDescription body article font2">
        <p>Ladd's magisterial work on New Testament theology has well served thousands of seminary students since its publication in 1974. Enhanced and updated here by Donald A Hagner, this comprehensive, standard evangelical text now features augmented bibliographies and two completely new chapters on subjects that Ladd himself wanted to treat in a revised edition—the theology of each of the Synoptic Evangelists and the issue of unity and diversity in the New Testament—written, respectively, by R. T. France and David Wenham.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George Eldon Ladd
      </h2>
      
      <p class="authorDescription body article">&#160;George Eldon Ladd (1911&ndash;1982) was professor of New Testament exegesis and theology at Fuller Theological Seminary, Pasadena, California. His numerous books include&#160;<I>The New Testament and Criticism, A Commentary on the Revelation of John</I>, and&#160;<I>Theology of the New Testament.</I>&quot;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?300f6506